var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Breadcrumb_1;
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { expression, string, tuple } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { Link } from '../link/link.js';
import { BreadcrumbAPI } from './breadcrumb-api.js';
import './breadcrumb.css';
let Breadcrumb = Breadcrumb_1 = class Breadcrumb extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            loaded: false,
            params: {},
            path: '',
        };
    }
    componentDidMount() {
        if (this.state.loaded) {
            return;
        }
        const listen = (match) => {
            if (!match) {
                return;
            }
            const { pathname: path = '', params = {} } = match;
            this.setState({ params, path });
        };
        this.unlisten = HistoryService.listenMatch(listen);
        this.setState({ loaded: true });
        listen(HistoryService.getMatch());
    }
    componentWillUnmount() {
        if (isFunction(this.unlisten)) {
            this.unlisten();
        }
    }
    redirect(path) {
        HistoryService.push(path);
    }
    render() {
        const { values = Breadcrumb_1.defaultProps.values } = this.props;
        const { path = '', params = {} } = this.state;
        let url = '';
        const breadcrumbPieces = path.split('/').map(p => {
            url += `${p}/`;
            const isParam = p[0] === ':';
            const key = isParam ? p.substring(1) : p;
            const piece = values[key];
            if (piece) {
                const value = params[key];
                return {
                    description: piece,
                    hasValue: Boolean(value),
                    url,
                    value,
                };
            }
            return null;
        });
        const pieces = breadcrumbPieces.filter(p => p !== null);
        return (React.createElement("div", { className: "c-breadcrumb" }, pieces.map(piece => {
            if (!piece) {
                return null;
            }
            return (React.createElement("span", { className: "c-breadcrumb-item", key: piece.description },
                React.createElement(Link, { className: "c-breadcrumb-item__description", onClick: () => this.redirect(piece.url), value: piece.description }),
                piece.hasValue ? (React.createElement("span", { className: "c-breadcrumb-item__value" }, piece.value)) : null));
        })));
    }
};
Breadcrumb.propTypes = {
    values: tuple([string, expression]),
};
Breadcrumb.defaultProps = {
    values: {},
};
Breadcrumb = Breadcrumb_1 = __decorate([
    AwesomeComponent({ api: BreadcrumbAPI, type: ComponentType.DATA_DISPLAY })
], Breadcrumb);
export { Breadcrumb, };
export default Breadcrumb;
//# sourceMappingURL=breadcrumb.js.map